(() => {
  const selector = '[data-kp-subscription-minimum]';
  const nativeFetch = window.fetch.bind(window);
  const cartAddPath = /\/cart\/add(?:\.js)?$/;
  const cartChangePath = /\/cart\/change(?:\.js)?$/;

  const planId = (value) => String(value || '').split('/').pop();

  const appstleSellingPlans = () => {
    const helper = document.getElementById('subscription-helper');
    const source = helper?.textContent || '';
    const directMatch = source.match(/"sellingPlansJson"\s*:\s*(\[[\s\S]*?\])\s*,\s*"widgetEnabled"/);
    const encodedMatch = source.match(
      /"sellingPlansJson"\s*:\s*appstleJsonSetting\(("(?:\\.|[^"\\])*")\)/
    );

    if (!directMatch && !encodedMatch) return [];

    try {
      const plans = directMatch
        ? JSON.parse(directMatch[1])
        : JSON.parse(JSON.parse(encodedMatch[1]));
      return Array.isArray(plans) ? plans : [];
    } catch (_) {
      return [];
    }
  };

  const tierForGroup = (groupName) => {
    if (!/PDP Grötbars/i.test(groupName || '')) return 0;
    const match = String(groupName).match(/([23])\s*\+/);
    return match ? Number.parseInt(match[1], 10) : 0;
  };

  const matchingTierPlan = (currentPlanId, tier, plans) => {
    const currentPlan = plans.find((plan) => planId(plan.id) === planId(currentPlanId));
    if (!currentPlan) return 0;

    const targetPlan = plans.find((plan) => {
      return (
        tierForGroup(plan.groupName) === tier &&
        plan.frequencyInterval === currentPlan.frequencyInterval &&
        Number(plan.frequencyCount) === Number(currentPlan.frequencyCount)
      );
    });

    return Number.parseInt(planId(targetPlan?.id), 10) || 0;
  };

  const bundleReference = (item) => item?.properties?.['_appstle-bb-id'] || '';

  const selectedBundlePlanId = () => {
    return document.querySelector('[data-kp-bab][data-kp-bab-selected-plan-id]')
      ?.dataset.kpBabSelectedPlanId || '';
  };

  const readCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await nativeFetch(`${root}cart.js`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    return response.ok ? response.json() : null;
  };

  const retierBundleCart = async (bundleTiers, plans) => {
    let cart = await readCart();
    const root = window.Shopify?.routes?.root || '/';

    for (let attempt = 0; cart && attempt < 30; attempt += 1) {
      const item = cart.items.find((candidate) => {
        const tier = bundleTiers.get(bundleReference(candidate));
        if (!tier || !candidate.selling_plan_allocation) return false;
        const currentPlanId = candidate.selling_plan_allocation.selling_plan.id;
        const targetPlanId = matchingTierPlan(currentPlanId, tier, plans);
        return targetPlanId && planId(currentPlanId) !== String(targetPlanId);
      });

      if (!item) return;

      const tier = bundleTiers.get(bundleReference(item));
      const targetPlanId = matchingTierPlan(
        item.selling_plan_allocation.selling_plan.id,
        tier,
        plans
      );
      const response = await nativeFetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          selling_plan: targetPlanId,
        }),
      });

      if (!response.ok) return;
      cart = await response.json();
    }
  };

  const adjustedCartAdd = async (resource, options) => {
    const request = resource instanceof Request ? resource : null;
    const requestUrl = request?.url || String(resource);
    let path;

    try {
      path = new URL(requestUrl, window.location.origin).pathname;
    } catch (_) {
      return null;
    }

    if (!cartAddPath.test(path)) return null;

    let rawBody = options?.body;
    if (rawBody === undefined && request) rawBody = await request.clone().text();
    if (typeof rawBody !== 'string') return null;

    let payload;
    try {
      payload = JSON.parse(rawBody);
    } catch (_) {
      return null;
    }

    if (!Array.isArray(payload.items)) return null;

    const bundleItems = payload.items.filter((item) => bundleReference(item));
    if (!bundleItems.length) return null;

    const plans = appstleSellingPlans();
    if (!plans.length) return null;

    const cart = await readCart();
    const bundleTotals = new Map();

    (cart?.items || []).forEach((item) => {
      const reference = bundleReference(item);
      if (!reference) return;
      bundleTotals.set(reference, (bundleTotals.get(reference) || 0) + Number(item.quantity || 0));
    });

    bundleItems.forEach((item) => {
      const reference = bundleReference(item);
      bundleTotals.set(reference, (bundleTotals.get(reference) || 0) + Number(item.quantity || 0));
    });

    const bundleTiers = new Map();
    bundleTotals.forEach((quantity, reference) => {
      if (quantity >= 2) bundleTiers.set(reference, 2);
    });

    const selectedPlanId = selectedBundlePlanId();
    const nextItems = payload.items.map((item) => {
      const tier = bundleTiers.get(bundleReference(item));
      const sourcePlanId = selectedPlanId || item.selling_plan;
      if (!tier || !sourcePlanId) return item;
      const targetPlanId = matchingTierPlan(sourcePlanId, tier, plans);
      return targetPlanId ? { ...item, selling_plan: targetPlanId } : item;
    });
    const nextBody = JSON.stringify({ ...payload, items: nextItems });

    if (request) {
      return {
        resource: new Request(request, { ...options, body: nextBody }),
        options: undefined,
        bundleTiers,
        plans,
      };
    }

    return {
      resource,
      options: { ...options, body: nextBody },
      bundleTiers,
      plans,
    };
  };

  const itemForChange = (cart, payload) => {
    if (payload.id !== undefined && payload.id !== null) {
      const id = String(payload.id);
      const byKey = cart.items.find((item) => item.key === id);
      if (byKey) return byKey;

      const variantId = Number.parseInt(id, 10);
      if (Number.isFinite(variantId)) {
        const byVariant = cart.items.filter((item) => item.variant_id === variantId);
        if (byVariant.length === 1) return byVariant[0];
      }
    }

    const line = Number.parseInt(payload.line || '0', 10);
    return line > 0 ? cart.items[line - 1] : null;
  };

  const adjustedCartChange = async (resource, options) => {
    const request = resource instanceof Request ? resource : null;
    const requestUrl = request?.url || String(resource);
    let path;

    try {
      path = new URL(requestUrl, window.location.origin).pathname;
    } catch (_) {
      return null;
    }

    if (!cartChangePath.test(path)) return null;

    let rawBody = options?.body;
    if (rawBody === undefined && request) rawBody = await request.clone().text();
    if (typeof rawBody !== 'string') return null;

    let payload;
    try {
      payload = JSON.parse(rawBody);
    } catch (_) {
      return null;
    }

    const requestedQuantity = Number.parseInt(payload.quantity, 10);
    if (!Number.isFinite(requestedQuantity) || requestedQuantity === 0) return null;

    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await nativeFetch(`${root}cart.js`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!cartResponse.ok) return null;

    const cart = await cartResponse.json();
    const item = itemForChange(cart, payload);
    const properties = item?.properties || {};
    if (properties._kp_subscription_source !== 'product_page') return null;

    const quantity = Math.max(2, requestedQuantity);
    const planId = Number.parseInt(properties._kp_subscription_plan_2 || '0', 10);
    if (!planId) return null;

    const nextBody = JSON.stringify({
      ...payload,
      quantity,
      selling_plan: planId,
    });

    if (request) {
      return {
        resource: new Request(request, { ...options, body: nextBody }),
        options: undefined,
      };
    }

    return {
      resource,
      options: { ...options, body: nextBody },
    };
  };

  window.fetch = async (resource, options) => {
    try {
      const adjustedAdd = await adjustedCartAdd(resource, options);
      if (adjustedAdd) {
        const response = await nativeFetch(adjustedAdd.resource, adjustedAdd.options);
        if (response.ok) await retierBundleCart(adjustedAdd.bundleTiers, adjustedAdd.plans);
        return response;
      }

      const adjusted = await adjustedCartChange(resource, options);
      if (adjusted) return nativeFetch(adjusted.resource, adjusted.options);
    } catch (_) {
      // Preserve the cart's native behaviour if the extra tier lookup fails.
    }

    return nativeFetch(resource, options);
  };

  const minimumFor = (input) => Number.parseInt(input.dataset.kpSubscriptionMinimum || '2', 10);

  document.addEventListener('click', (event) => {
    const decrease = event.target.closest('[data-decrease-quantity]');
    const input = decrease?.closest('[data-quantity-selector]')?.querySelector(selector);
    if (!input) return;

    const quantity = Number.parseInt(input.value || '0', 10);
    const minimum = minimumFor(input);
    if (quantity > minimum) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = String(minimum);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.(selector);
    if (!input) return;

    const quantity = Number.parseInt(input.value || '0', 10);
    const minimum = minimumFor(input);
    if (quantity !== 0 && quantity < minimum) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = String(minimum);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const line = Number.parseInt(input.dataset.kpCartLine || '0', 10);
    const row = input.closest('[data-cart-item]');
    const tiers = [...(row?.querySelectorAll('[data-kp-cart-tier]') || [])]
      .map((tier) => ({
        threshold: Number.parseInt(tier.dataset.kpThreshold || '0', 10),
        planId: tier.dataset.kpPlanId,
      }))
      .filter((tier) => tier.threshold > 0 && tier.planId)
      .sort((left, right) => left.threshold - right.threshold);

    if (!line || quantity < minimum || !tiers.length) return;

    let activeTier = tiers[0];
    tiers.forEach((tier) => {
      if (quantity >= tier.threshold) activeTier = tier;
    });

    if (activeTier.planId === input.dataset.kpCurrentSellingPlan) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const root = window.Shopify?.routes?.root || '/';
    window.fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        line,
        quantity,
        selling_plan: Number(activeTier.planId),
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Could not update subscription tier');
        return response.json();
      })
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart },
          bubbles: true,
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(() => {
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }, true);
})();
